<template>

</template>
<script>
  export default {
    props: {
      sitekey: String,
      action: String
    },
    data() {
      return {}
    },
    mounted() {
      if (!this.sitekey) {
        console.log('Provide SiteKey for Google Recaptcha')
        return
      }
      if (!this.checkRecaptchaLoad()) {
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${this.sitekey}`);
        document.head.appendChild(recaptchaScript);
      }
    },
    methods: {
      generateToken() {
        if (this.checkRecaptchaLoad()) {
          return window.grecaptcha.execute(this.sitekey, {action: this.action});
        } else {
          console.log('grecaptcha not loaded')
          return undefined
        }
      },
      checkRecaptchaLoad() {
        if (typeof window === 'undefined') {
          return false
        }
        const isLoaded = Object.hasOwn(window, 'grecaptcha') && Object.hasOwn(window.grecaptcha, 'execute')
        return isLoaded
      }
    },
  }
</script>

<style>
  /* .grecaptcha-badge {
    visibility: hidden;
  } */
</style>